/* eslint-disable no-useless-escape */

/**
 * Name Regex
 * accepts a-z, A-Z, 0-9, spaces, ._-
 */
export const NAME_REGEX = {
    pattern: /^[a-zA-Z0-9\s.\-_()]*$/,
    msg    : "Please enter a valid input with only alphanumeric characters, spaces, periods, underscores, hyphens, and parentheses"
};

/**
 * Alpha Numeric Regex
 * accepts a-z, A-Z, 0-9,space
 * bypasses if nothing
 **/
export const ALPHA_NUMERIC_UNDERSCORE_REGEX = {
    pattern: /^[a-zA-Z0-9_]+$/,
    msg    : "Please enter a valid input with only letters, numbers, and underscore."
};

/**
 * Alpha Numeric Regex
 * accepts a-z, A-Z, 0-9,space
 * bypasses if nothing
 **/
export const ALPHA_NUMERIC_REGEX = {
    pattern: /^[a-zA-Z0-9\s]*$/,
    msg    : "Please enter a valid input with only letters, numbers, and spaces."
};

/**
 * Alpha Numeric Regex
 * accepts a-z, A-Z, 0-9, without space
 * bypasses if nothing
 **/
export const ALPHA_NUMERIC_WITHOUT_SPACE_REGEX = {
    pattern: /^[a-zA-Z0-9_-]*$/,
    msg    : "Please enter a valid input with only letters, numbers, underscores, and hyphens"
};

/* This is checking for the following:
1. `^` - Start of the string
2. `$` - End of the string
3. `|` - OR
4. `[a-zA-Z0-9_-]` - Checks for one or more alphanumeric characters, hyphens, or underscores
5. `*` - Checks for zero or more of the above
6. `$` - End of the string */
export const ALPHA_NUMERIC_SPECIAL_CASE = {
    pattern: /^[a-zA-Z0-9\s()[\]&@$.,_ -]*$/,
    msg    : "Please enter a valid value using only letters (both uppercase and lowercase), numbers, spaces, parentheses (), square brackets [], ampersand (&), at symbol (@), dollar sign ($), comma (,), period (.), underscore (_), hyphen (-), or whitespace. Special characters or symbols other than these are not allowed."
};

/**
 * Event Name Regex
 **/
/* contains only letters, numbers, underscores, and hyphens. */
export const EVENT_NAME_REGEX = {
    pattern: /^[a-zA-Z0-9_-\s]*$/,
    msg    : "Please enter a valid input with only letters, numbers, underscores, hyphens, and spaces."
};

/**
 * PHONE Number Regex
 */
/* This is checking for the following:
 1. `^` - Start of the string
 2. `$` - End of the string
 3. `|` - OR
 4. `[+]?` - Checks for an optional plus sign
 5. `(\d{1,2})?` - Checks for one or two digits
 6. `[\s.-]?` - Checks for an optional space, period, or hyphen
 7. `\(?` - Checks for an optional left parenthesis
 8. `\d{3}` - Checks for three digits
 9. `\)?` - Checks for an optional right parenthesis
 10. `[\s.-]?` - Checks for an optional space, period, or hyphen
 11. `\d{3}` - Checks for three digits
 12. `[\s.-]?` - Checks for an optional space, period, or hyphen
 13. `\d{4}` - Checks for four digits
 14. `$` - End of the string */
export const PHONE_NUM_REGEX = {
    pattern: /^$|^[+]?(\d{1,2})?[\s.-]?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
    msg    : "Invalid Phone Number"
};

/**
 * PASSWORD REGEX
 */
/* This is checking for the following:
 1. `^` - Start of the string
 2. `$` - End of the string
 3. `|` - OR
 4. `(?=.*?[A-Za-z])` - Checks for one or more characters that are either an uppercase or lowercase
 letter
 5. `(?=.*?[0-9])` - Checks for one or more digits
 6. `(?=.*?[#?!@$%^&*-])` - Checks for one or more characters that are either a hash, a question
 mark,
 an exclamation point, an at sign, a dollar sign, a percent sign, a caret, an ampersand, an asterisk,
 or a hyphen
 7. `.{8,32}` - Checks for any character that is between 8 and 32 characters long
 8. `$` - End of the string */
export const PASSWORD_REGEX = {
    pattern: /^$|^(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,32}$/,
    msg    : "Please enter a valid password between 8 and 32 characters that contains at least one letter, one number, and one special character from the set #?!@$%^&*-"
};

export const EMAIL_REGEX = {
    pattern: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
    msg    : "Please enter a valid email"
};
  
export const SKYPE_REGEX = {
    pattern: /^[a-zA-Z][a-zA-Z0-9._-]{5,31}$/,
    msg    : "Please enter a valid skype ID"
};
/**
 * URL Regex
 */

/* This is checking for the following:
1. `^` - Start of the string
2. `$` - End of the string
3. `|` - OR
4. `(http|https)?` - Checks for either `http` or `https`
5. `:\/\/` - Checks for `://` */
export const URL_REGEX = {
    pattern:
    /^$|^https?:\/\/(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[a-zA-Z0-9\/._-]*)?/,
    msg: "The provided string does not match the expected URL pattern. Ensure it starts with 'http' or 'https', followed by optional 'www.', a valid domain, and an optional path. Avoid spaces or newline characters within the URL."
};